var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Link } from "@reach/router";
import styled, { css } from "styled-components";
import tinycolor from "tinycolor2";
import { forPrint } from "@gw/theming";
export var ButtonLink = styled(Link)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-decoration: none;\n  color: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  padding: 9px 16px;\n  border: none;\n  transition: background-color ", " ease;\n  cursor: pointer;\n  ", "\n  &:hover {\n    background-color: ", ";\n  }\n  &.blue {\n    background-color: ", ";\n    &:hover {\n      background-color: ", ";\n    }\n  }\n  &.smallish {\n    font-size: 1.4rem;\n    letter-spacing: 0.2px;\n    padding: 6px 12px;\n  }\n"], ["\n  text-decoration: none;\n  color: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  padding: 9px 16px;\n  border: none;\n  transition: background-color ", " ease;\n  cursor: pointer;\n  ",
    "\n  &:hover {\n    background-color: ",
    ";\n  }\n  &.blue {\n    background-color: ", ";\n    &:hover {\n      background-color: ", ";\n    }\n  }\n  &.smallish {\n    font-size: 1.4rem;\n    letter-spacing: 0.2px;\n    padding: 6px 12px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.accent3;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius;
}, function (_a) {
    var theme = _a.theme;
    return theme.transitions.normal;
}, forPrint(css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "])))), function (_a) {
    var theme = _a.theme;
    return tinycolor(theme.colors.accent3).lighten(5).toString();
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.buttons.main.hoverBg;
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=ButtonLink.js.map